<!-- A Chat bubble with incoming and outgoing variants -->
<template>
  <div :class="['chat-bubble', incoming ? 'incoming' : 'outgoing']">
    <div class="bubble-content">
      <slot/>
    </div>
  </div>
</template>

<script setup>
defineProps({
  incoming: {
    type: Boolean,
    default: false
  }
})
</script>

<style lang="scss" scoped>
.chat-bubble {
  --bubble-animation-duration: 2s;
  display: flex;
  padding: $spacing-sm $spacing-md;
  animation: slideAndFade var(--bubble-animation-duration) ease-in-out;
  animation-fill-mode: backwards;
  width: fit-content;  
  &.incoming {
    background-color: $teal;
    color: $white;
    border-radius: 8px 8px 8px 0px;
    align-self: flex-start;
    animation-delay: 0.2s;
    margin-left: $spacing-md;
    margin-right: $spacing-xxl;
  }
  &.outgoing {
    --bubble-animation-duration: 1s;
    background-color: $origami;
    border: .5px solid $teal;
    color: $armor;
    border-radius: 8px 8px 0px 8px;
    align-self: flex-end;
    animation-delay: 0;
    margin-left: $spacing-xxl;
    margin-right: $spacing-md;
  }
}
@keyframes slideAndFade {
  0% {
    transform: translateY(50px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
